/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseTemplateChat } from '../../models/api-response-template-chat';

export interface GetTemplateByReference$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
}

export function getTemplateByReference(http: HttpClient, rootUrl: string, params: GetTemplateByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateChat>> {
  const rb = new RequestBuilder(rootUrl, getTemplateByReference.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseTemplateChat>;
    })
  );
}

getTemplateByReference.PATH = '/v1/api/ui/templates-chat/{reference}';
